import { generalSettingsActionTypes } from '../constants/ApiConstants';

const initialState = {
  masterData: null,
  patientGeneralSettingsDetails: null,
  saved_patientGeneralSettings: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case generalSettingsActionTypes.get_masterData.REQUEST:
      return {
        ...state,
        masterData: null,
      };
    case generalSettingsActionTypes.get_masterData.SUCCESS:
      return {
        ...state,
        masterData: payload,
      };
  case generalSettingsActionTypes.save_patientGeneralSettings.REQUEST:
    return {
      ...state,
      loading: true,
      saved_patientGeneralSettings: null,
    };
    case generalSettingsActionTypes.save_patientGeneralSettings.SUCCESS:
    return {
      ...state,
      loading: false,
      saved_patientGeneralSettings: payload,
    };
    case generalSettingsActionTypes.get_patientGeneralSettings.REQUEST:
    return {
      ...state,
      loading: true,
      patientGeneralSettingsDetails: null,
    };
    case generalSettingsActionTypes.get_patientGeneralSettings.SUCCESS:
    return {
      ...state,
      loading: false,
      patientGeneralSettingsDetails: payload,
    };
  default:
    return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/SetUp/generalSettings/reducers/GeneralSettingsReducer.js